'use client';

import { AuthorBox, AuthorBoxVariant } from '@/components/magazine/AuthorBox';
import { useOptionalRenderContext } from '@/lib/render/RenderContextProvider';

/**
 * The full-width author box below the article body, at the position an editor
 * gave this block on the article Template Page (spec 10.03.02.02.09).
 *
 * `AuthorBox` carries the `id="autor"` the route-rendered author chip links
 * down to, which is why `autor` stays reserved in the anchor pass.
 */
export const MagazineAuthorBoxComponent = () => {
  const ctx = useOptionalRenderContext();

  const article = ctx?.entities.article;
  const author = article?.author;

  // Inert on any other Page, and omitted on an article with no author
  // (10.02.03 § AC 5).
  if (!article || !author) {
    return null;
  }

  return (
    <div className="py-8">
      <AuthorBox
        author={author}
        variant={AuthorBoxVariant.Article}
        recentArticles={article.recentArticles}
      />
    </div>
  );
};
